import * as Reakit from 'reakit/Menu'

import { Paragraph } from '../typography'

export function DropdownSeparator(props: Partial<Reakit.MenuSeparatorProps>) {
  return (
    <Reakit.MenuSeparator {...props} as="div" className="group">
      <div className="my-1 border-t border-gray-100 group-first:hidden dark:border-gray-600" />
      {props.children && (
        <Paragraph size="small" className="px-2 text-gray-500">
          {props.children}
        </Paragraph>
      )}
    </Reakit.MenuSeparator>
  )
}
